/**
 * Lectures Number Cell - Frontend
 * @description Cell component for displaying lecture number in LecturesTable
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { LecturesTableData } from '@/types/operational-ui.types';

interface LectureOperationIdCellProps {
  info: CellContext<LecturesTableData, string>;
}

export const LectureOperationIdCell: React.FC<LectureOperationIdCellProps> = ({ info }) => {
  /**
   * Value example: 68d8f17682389e53163b89f8
   * 
   * We need to show the last 6 characters
   */
  const operationIdentifier = info.getValue();

  return (
    <div className="font-medium text-center text-gray-900">{operationIdentifier?.slice(-6)}</div>
  );
};
